import { TierLevel, TIER_RANK_MAP } from '../../../domain/enums/TierLevel';
import { DelinquencyStatus } from '../../../domain/enums/SystemEnums';
import type { BadgeTone } from '../../components/ui/Badge';

/** Member status → badge tone / card accent (PRD 7.5.1 A status dot). */
export const STATUS_TONE: Record<DelinquencyStatus, BadgeTone> = {
  ACTIVE: 'success',
  DUE: 'warning',
  IN_NOTICE_PERIOD: 'warning',
  INACTIVE: 'danger',
  DISABLED_DEFAULT: 'danger',
  SUSPENDED: 'danger',
  CLOSED: 'neutral',
};

export type StatusAccent = 'ok' | 'warn' | 'bad' | 'closed';

export function statusAccent(status: DelinquencyStatus, overdueMonths = 0): StatusAccent {
  if (status === DelinquencyStatus.CLOSED) return 'closed';
  if (
    status === DelinquencyStatus.INACTIVE ||
    status === DelinquencyStatus.DISABLED_DEFAULT ||
    status === DelinquencyStatus.SUSPENDED
  ) {
    return 'bad';
  }
  if (status !== DelinquencyStatus.ACTIVE || overdueMonths > 0) return 'warn';
  return 'ok';
}

export function tierTone(tier: TierLevel): BadgeTone {
  if (tier === TierLevel.L6) return 'accent';
  if (TIER_RANK_MAP[tier] >= 3) return 'info';
  if (tier === TierLevel.L2) return 'success';
  return 'neutral';
}

export const isAgent = (tier: TierLevel) => TIER_RANK_MAP[tier] >= 2 && tier !== TierLevel.ADMIN;

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

export const telHref = (phone: string) => `tel:+88${phone}`;
